export default __webpack_public_path__ + "static/media/Oro-1Closed.c28d0181.jpg";